import { render, staticRenderFns } from "./SundryCreditorListSideMenu.vue?vue&type=template&id=fba5bb4e&scoped=true"
import script from "./SundryCreditorListSideMenu.vue?vue&type=script&lang=js"
export * from "./SundryCreditorListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./SundryCreditorListSideMenu.vue?vue&type=style&index=0&id=fba5bb4e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba5bb4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fba5bb4e')) {
      api.createRecord('fba5bb4e', component.options)
    } else {
      api.reload('fba5bb4e', component.options)
    }
    module.hot.accept("./SundryCreditorListSideMenu.vue?vue&type=template&id=fba5bb4e&scoped=true", function () {
      api.rerender('fba5bb4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sundrycreditor/SundryCreditorListSideMenu.vue"
export default component.exports